/* angular:styles/component:css;39e60f9911ab9a5f;/home/runner/work/app/app/src/app/components/member-budget-banner/member-budget-banner.component.ts */
:host {
  display: block;
}
.budget-banner__compose {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  margin-left: 0.5rem;
}
.budget-banner__input {
  min-width: 14rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid var(--border-color);
  border-radius: 0.375rem;
  background: var(--background-color, transparent);
  color: var(--text-color);
  font: inherit;
  font-size: 0.8125rem;
}
.budget-banner__send,
.budget-banner__cancel {
  padding: 0.25rem 0.7rem;
  border-radius: 0.5rem;
  font: inherit;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
}
.budget-banner__send {
  border: none;
  background: var(--accent-color, #4c17ca);
  color: var(--accent-contrast, #fff);
}
.budget-banner__cancel {
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--text-secondary-color, #475569);
}
.budget-banner__send:disabled,
.budget-banner__cancel:disabled {
  opacity: .5;
  cursor: default;
}
.budget-banner__sent {
  font-weight: 500;
}
/*# sourceMappingURL=member-budget-banner.component-KEZEENPM.css.map */
